import { Component, ViewChild, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CallbackElement } from '../../interfaces/callbackElement';

@Component({
  selector: 'app-callbacks-table',
  templateUrl: './callbacks-table.component.html',
  styleUrls: ['./callbacks-table.component.css']
})
export class CallbacksTableComponent implements OnChanges {

  @Input() loading: boolean = true;
  @Input() ELEMENT_DATA: CallbackElement[] = [];
  @Input() canEdit: boolean = false;
  @Output() onEditCallback = new EventEmitter<CallbackElement>();

  displayedColumns: string[] = ['type', 'skill', 'date', 'rut', 'name', 'comment', 'can_edit_callback'];
  dataSource = new MatTableDataSource<CallbackElement>(this.ELEMENT_DATA);
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor() { }

  ngAfterViewInit() {
    console.log(this.ELEMENT_DATA)
    this.dataSource.paginator = this.paginator;
  }

  ngOnChanges(changes) {
    //console.log(changes, 'changes-ngOnChanges');
    if (changes.ELEMENT_DATA) {
      this.dataSource = new MatTableDataSource<CallbackElement>(this.ELEMENT_DATA);
      this.dataSource.paginator = this.paginator;
    }
    
  }

  editCallback(element: CallbackElement) {
    this.onEditCallback.emit(element);
  }

}
